'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var AttachmentIcon = function AttachmentIcon(_ref) {
  var color = _ref.color,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === undefined ? 'transparent' : _ref$fillColor,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ['color', 'fillColor', 'height', 'width']);

  return _react2.default.createElement('svg', _extends({
    viewBox: '0 0 24 24',
    width: width,
    height: height
  }, props), _react2.default.createElement('polygon', {
    points: '16.4226225 3 14.1935359 3.60868882 4.74372393 13.0042835 4 16.0127129 5.62646169 19.6528206 8.41959686 21 11.8084062 20.4107638 21 11.305543 18.5782055 8.8409015 19.0826519 6.05051775 17.911808 3.60868882',
    fill: fillColor,
    transform: 'translate(-0.25, -0.25)'
  }), _react2.default.createElement('path', {
    d: 'M8.75 21.91a6 6 0 0 1-4.23-10.24l8-8a4.25 4.25 0 0 1 6 6l-8 8a2.56 2.56 0 0 1-3.53 0 2.5 2.5 0 0 1 0-3.53l7.41-7.41a.77.77 0 0 1 1.07 0 .75.75 0 0 1 0 1.06L8 15.21a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l8-8a2.75 2.75 0 0 0-3.81-3.91l-8 8a4.49 4.49 0 1 0 6.35 6.35l8-8A.75.75 0 1 1 21 12.12l-8 8a6 6 0 0 1-4.25 1.79z',
    fill: color
  }));
};

exports.AttachmentIcon = AttachmentIcon;